import VeeValidate, { Validator } from 'vee-validate'
import i18n from '../translation'
import Vue from 'vue'

import fr from 'vee-validate/dist/locale/fr'
import es from 'vee-validate/dist/locale/es'

Validator.localize('fr', fr)
Validator.localize('es', es)

const config = {
  errorBagName: 'wzErrors', // change if property conflicts.
  fieldsBagName: 'wzFields',
  delay: 0,
  locale: i18n.locale, // le validator affichera les messages d'erreurs dans la langue du module i18n de traduction
  // dictionary: dictionary, // mise à jour du dictionnaire de traduction des erreurs
  strict: true,
  enableAutoClasses: false,
  classNames: {
    touched: 'touched', // the control has been blurred
    untouched: 'untouched', // the control hasn't been blurred
    valid: 'valid', // model is valid
    invalid: 'invalid', // model is invalid
    pristine: 'pristine', // control has not been interacted with
    dirty: 'dirty'  // control has been interacted with
  },
  events: 'input|blur',
  inject: true
}

Vue.use(VeeValidate, config)

export default VeeValidate



// WEBPACK FOOTER //
// ./src/validator/index.js